module.exports = __webpack_public_path__ + "./images/29b4baac774f53e1e377acd8f7e659e3.webp";